import { render, staticRenderFns } from "./OrdemColetaDetalhes.vue?vue&type=template&id=0ad8bde2"
import script from "./OrdemColetaDetalhes.vue?vue&type=script&lang=js"
export * from "./OrdemColetaDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports